<div class="flex flex-col border w-full !px-0 !py-0 soft-input border-secondary max-h-[24rem]">
  <div class="w-full h-10 min-h-[2.5rem] flex-shrink-0 flex items-center border-b border-solid border-b-secondary">
    @for (view of views; track view) {
      @if (view.visible$ | async) {
        <div class="flex items-center text-sm uppercase px-4 leading-relaxed font-medium tracking-wide border-r border-solid border-r-secondary h-full"
          (click)="selectedChange.emit(view.id)"
          [ngClass]="selected === view.id ? 'text-primary font-semibold bg-secondary-100' : ''">
          <span [ngClass]="selected === view.id ? '' : 'opacity-60'">{{ view.label }}</span>
        </div>
      }
    }
  </div>

  <div class="min-h-[4rem] flex flex-col gap-0 soft-scroll soft-scroll-vertical">
    @switch (selected) {
      @case ('results') {
        <ng-container *ngTemplateOutlet="resultTemplate"></ng-container>
      }
      @case ('edit') {
        <ng-container *ngTemplateOutlet="editTemplate"></ng-container>
      }
      @case ('create') {
        <ng-container *ngTemplateOutlet="createTemplate"></ng-container>
      }
      @default {
        <div class="min-h-[4rem] h-full flex w-full items-center justify-center py-4 px-4 text-center text-sm opacity-70">
          Bitte wählen Sie eine Registerkarte!
        </div>
      }
    }
  </div>
</div>
